/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/launch_medium'
export default icon
